import { createTheme } from '@mui/material/styles';
import { darkPalette } from './palette';
import typography from './typography';
import getComponents from './components';

const darkTheme = createTheme({
  palette: darkPalette,
  typography,
  components: getComponents('dark'),
  shape: { borderRadius: 8 },
});

export default darkTheme;
